import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';

export const getProductsWithRequiredData = (products: TComplimentaryProductInfo[]) =>
  products.filter(
    product =>
      Boolean(product.total.requiredQuantity) &&
      Boolean(product.productId) &&
      Boolean(product.salesPriceValueInConsumerUnitValue) &&
      Boolean(product.displayedName.value)
  );
